// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationProcessApi,
  ICertificationProcessApiRequest,
  ICertificationProcessApiGetAllAttrs,
  ICertificationProcessApiGetAllResponse,
  ICertificationProcessApiGetAttrs,
  ICertificationProcessApiGetResponse,
  ICertificationProcessApiSaveAttrs,
  ICertificationProcessApiSaveResponse,
} from 'interfaces/back-office/content-management/certification/process/certification-process-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class CertificationProcessApi extends BaseApi<ICertificationProcessApi> implements ICertificationProcessApiRequest {
  readonly url = ApiConstant.CONTENT_CERTIFICATION_PROCESS_URL
  private certificationProcessUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get certification process list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationProcessApiGetAllAttrs} payload
   *
   * @return {Promise<ICertificationProcessApiGetAllResponse>} Promise<ICertificationProcessApiGetAllResponse>
   */
  async certificationProcess_getList(
    payload: ICertificationProcessApiGetAllAttrs,
  ): Promise<ICertificationProcessApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.certificationProcessUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get certification process list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationProcessApiGetAttrs} payload
   *
   * @return {Promise<ICertificationProcessApiGetResponse>} Promise<ICertificationProcessApiGetResponse>
   */
  async certificationProcess_getDetail(payload: ICertificationProcessApiGetAttrs): Promise<ICertificationProcessApiGetResponse> {
    try {
      const response = await this.POST(`${this.certificationProcessUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save certification process
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationProcessApiSaveAttrs} payload
   *
   * @return {Promise<ICertificationProcessApiSaveResponse>} Promise<ICertificationProcessApiSaveResponse>
   */
  async certificationProcess_save(payload: ICertificationProcessApiSaveAttrs): Promise<ICertificationProcessApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.certificationProcessUrl}/update/${payload.params.id}`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
